__turbopack_context__.v({
  "field": "AssetNameRow-module__F2JwjW__field",
});
